import { endPoints, requestType } from "../lib/Variable";
import Api from "./index";

const createProduct = (_, params) => {
  return Api(endPoints.product, params, requestType.POST);
};

const getAllProducts = (query) => {
  let url = endPoints.product;

  if (query?.status) {
    url += `?status=${true}`;
  }

  return Api(url, null, requestType.GET);
};

const getProductById = (id) => {
  return Api(`${endPoints.product}/${id}`, null, requestType.GET);
};

const updateProduct = (id, params) => {
  return Api(`${endPoints.product}/${id}`, params, requestType.PUT);
};

export { createProduct, getAllProducts, getProductById, updateProduct };
